var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.voteCondition == 'RESULT')?_c('VoteResult'):(_vm.voteCondition == 'FORM')?_c('VoteForm'):(_vm.voteCondition == 'PROCESS')?_c('VoteProcess'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }